import React from 'react';
import { SeasonalComparatorImages } from 'types/Meteorology/Weather/SeasonalComparator/getImages';
import QueryErrorState from 'components/DesignSystem/QueryErrorState';
import CentralizedSpinner from 'components/CentralizedSpinner';
import EnlargeableImage from 'components/Meteorology/Fields/SynopticCharts/SynopticChart/Map/EnlargeableImage';
import useImageSelection from 'hooks/Meteorology/Weather/Comparator/useImageSelection';
import RoundTabButton from 'components/DesignSystem/Tabs/DiscreteTabs/RoundTabButton';
import { ResponseError } from 'services/api/base';

export default function ImageDisplay({
  images,
  queryError,
  onRetry,
  loading,
}: {
  images: SeasonalComparatorImages | undefined;
  queryError: ResponseError | undefined;
  onRetry: () => void;
  loading: boolean;
}) {
  const { buttonData, selected } = useImageSelection();

  if (loading) {
    return <CentralizedSpinner />;
  }

  if (queryError) {
    return (
      <QueryErrorState
        title={queryError.data}
        message={queryError.description}
        onRetry={onRetry}
      />
    );
  }

  if (!images) {
    return null;
  }

  return (
    <>
      <div className="d-flex justify-content-center round-discrete-tabs">
        {buttonData.map((button) => (
          <RoundTabButton
            key={button.text}
            onClick={button.onClick}
            text={button.text}
            active={button.active}
          />
        ))}
      </div>
      <div className="d-flex justify-content-center">
        <EnlargeableImage
          className="seasonal-forecast-image mt-5"
          src={`data:image/png;base64,${images[selected]}`}
        />
      </div>
    </>
  );
}
